/**
 * SourceProtection — Prevents casual inspection of source code.
 * - Blocks right-click context menu
 * - Blocks dev tools keyboard shortcuts (F12, Ctrl+Shift+I, Ctrl+U, Ctrl+Shift+J)
 * - Removes React DevTools hook
 * - Does NOT affect normal application functionality
 */
import { useEffect } from 'react';

export default function SourceProtection() {
  useEffect(() => {
    // Block right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Block dev tools keyboard shortcuts
    const handleKeyDown = (e) => {
      // F12
      if (e.key === 'F12') { e.preventDefault(); return false; }
      // Ctrl+Shift+I (Inspector)
      if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) { e.preventDefault(); return false; }
      // Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j')) { e.preventDefault(); return false; }
      // Ctrl+U (View Source)
      if (e.ctrlKey && (e.key === 'U' || e.key === 'u')) { e.preventDefault(); return false; }
      // Ctrl+Shift+C (Element picker)
      if (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'c')) { e.preventDefault(); return false; }
      // Cmd equivalents for Mac
      if (e.metaKey && e.altKey && (e.key === 'I' || e.key === 'i' || e.key === 'J' || e.key === 'j')) { e.preventDefault(); return false; }
      if (e.metaKey && (e.key === 'U' || e.key === 'u')) { e.preventDefault(); return false; }
    };

    // Disable text selection on double-click (optional, prevents some inspect behaviors)
    const handleSelectStart = (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) return;
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    // Remove React DevTools global hook
    if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function() {};
    }

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return null;
}
